import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgxPaginationModule, PaginationControlsDirective } from 'ngx-pagination';

@Component({
    selector: 'app-custom-pagination',
    templateUrl: './pagination.component.html',
    standalone: true,
    imports: [NgxPaginationModule, CommonModule],
    styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {

    @Output() pageChange: EventEmitter<number> = new EventEmitter();

    @Input() totalItems: number; // Total number of items
    @Input() itemsPerPage: number; // Number of items per page
    @Input() firstLastEnable: boolean = true;


    ngOnInit(): void {
        console.log("pagination loaded ...");
    }

    get totalPages(): number {
        return Math.ceil(this.totalItems / this.itemsPerPage);
    }





}
